<!--
 * @Author: 'chenrongda' '861191244@qq.com'
 * @Date: 2025-02-25 10:48:34
 * @LastEditors: 'chenrongda' '861191244@qq.com'
 * @LastEditTime: 2025-11-19 09:55:24
 * @FilePath: \official.site\src\views\AboutUs.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="we">
      <div class="me">
          <img src="../assets/me.datang.png" alt="">
          <img src="../assets/me01.png" alt="">
          <img src="../assets/me02.png" alt="">
          <img src="../assets/me03.png" alt="">
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='less'>

</style>